module.exports = __webpack_public_path__ + "static/media/stellantis-logo-white.e595e004.png";